
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import AudienceCard from "./AudienceCard";
import type { AudienceItem } from "./types";

interface MobileAudienceViewProps {
  audiences: AudienceItem[];
  isVisible: boolean;
}

const MobileAudienceView = ({ audiences, isVisible }: MobileAudienceViewProps) => {
  return (
    <div className={`transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <Carousel className="max-w-md mx-auto">
        <CarouselContent>
          {audiences.map((audience) => (
            <CarouselItem key={audience.id}>
              <AudienceCard 
                title={audience.title}
                description={audience.description}
                image={audience.image}
                features={audience.features}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="flex justify-center gap-2 mt-4">
          <CarouselPrevious className="static transform-none mx-2" />
          <CarouselNext className="static transform-none mx-2" />
        </div>
      </Carousel>
    </div>
  );
};

export default MobileAudienceView;
